import React from "react";
import {withFormik} from "formik";
import assets from "game/app/assets";

class BonusTaskInnerForm extends React.Component {

    attachmentInputRef = null;

    constructor(props) {
        super(props);
        this.state = {
            opened: false
        }
    }

    toggleOpened() {
        this.setState({...this.state, opened: !this.state.opened});
    }

    reset = () => {
        this.props.setFieldValue('attachment', '');
        this.props.setFieldValue('note', '');
        this.props.setStatus({});
    };

    renderForm() {
        return (
            <div>
                <div className='form-group'>
                    <label>Příloha</label>
                    <input type='file' className='form-control' id="attachment" name="attachment" onChange={(event) => { this.props.setFieldValue("attachment", event.currentTarget.files[0]); }} onBlur={this.props.handleBlur}/>
                </div>
                <div className='form-group'>
                    <label>Text pro hodnotitele</label>
                    <textarea className='form-control' name="note" id='note' onChange={this.props.handleChange} onBlur={this.props.handleBlur} value={this.props.values.note}/>
                </div>
                <div className='form-group'>
                    <button type='submit' className='btn btn-primary btn-block' disabled={this.props.isSubmitting}>Odeslat</button>
                </div>
            </div>
        )
    }

    renderResult(submission) {
        return (
            <div key={submission.id}>
                <div className='label'>Odevzdáno</div>
                <p>{new Date(submission.created_at).toLocaleString('cs-CZ')}</p>
                { submission.attachment !== null && <p><a target='_blank' className='btn btn-primary' href={submission.attachment}>Zobrazit přílohu</a></p> }
                { submission.note !== null && <div><div className='label'>Text pro hodnotitele</div><p style={{'whiteSpace':'pre-wrap'}}>{submission.note}</p></div> }
                { submission.evaluation_text !== null && <div><div className='label'>Hodnocení</div><p style={{'whiteSpace':'pre-wrap'}}>{submission.evaluation_text}</p></div> }
                { submission.evaluation_value !== null && <div><div className='label'>Chechtáků</div><p>{submission.evaluation_value}</p></div> }
                { submission.evaluation_value === null && <p>Probíhá vyhodnocení...</p> }
                <p>V případe jakéhokoliv dotazu ku získanému hodnocení nás můžete kontaktovat na <a href="mailto:rozpoctisito@gmail.com">rozpoctisito@gmail.com</a></p>
                <hr/>
            </div>
        );
    }

    render() {
        let task = this.props.resource;
        return (
            <div className='card bonus-task'>
                    <form onSubmit={this.props.handleSubmit}>
                        <div className='description'>
                            <div>
                                <img className='task-indicator' src={assets.task.task_simple}/>
                            </div>
                            <div className='info'>
                                <h4>{ task.name }</h4>
                                <p><strong>Chechtáků: { task.chechtaky }</strong></p>
                                <div dangerouslySetInnerHTML={{__html: task.description}}/>
                            </div>
                            <div className='actions'><button type='button' className={`btn btn-${ this.state.opened ? 'outline-primary' : 'primary' }`} onClick={() => { this.toggleOpened(); }}>{ this.state.opened ? 'Skrýt' : 'Zobrazit' }</button></div>
                        </div>
                        <div className={`options ${ this.state.opened ? 'opened' : '' }`}>
                            { task.submissions.sort((a,b) => a.id - b.id).map((submission) => this.renderResult(submission)) }
                            { this.renderForm() }
                        </div>
                    </form>
            </div>
        )
    }
}

const BonusTaskForm = withFormik({
    mapPropsToValues: props => ({ note: '', attachment: undefined }),
    validate: () => {},
    handleSubmit: (values, bag) => { bag.props.handleSubmit(values, bag) }
})(BonusTaskInnerForm);

export default BonusTaskForm;
